
import React, { useState } from 'react';
import Nav from '../Home/Nav/Nav.js';
import { FaLongArrowAltLeft } from "react-icons/fa";
import { Link as RouterLink } from 'react-router-dom';
import './FAQ.css';
import { useTranslation } from 'react-i18next';

import QuestionReponse from './QuestionReponse';

const FAQ = () => {
     const { t, i18n } = useTranslation();
      
          const changeLanguage = (e) => {
            i18n.changeLanguage(e.target.value);
        };
    const [openQuestionId, setOpenQuestionId] = useState(null);
const handleToggle = (id) => {
        setOpenQuestionId(openQuestionId === id ? null : id);
    };    const donneesFAQ = [
        { id: 1, q: t('faq.q1'), r: t('faq.r1') },
        { id: 2, q: t('faq.q2'), r: t('faq.r2') },
        { id: 3, q: t('faq.q3'), r: t('faq.r3') },
        { id: 4, q: t('faq.q4'), r: t('faq.r4') },
        { id: 5, q: t('faq.q5'), r: t('faq.r5') },
        { id: 6, q: t('faq.q6'), r: t('faq.r6') },
        { id: 7, q: t('faq.q7'), r: t('faq.r7') },
        { id: 8, q: t('faq.q8'), r: t('faq.r8') },
        { id: 9, q: t('faq.q9'), r: t('faq.r9') },
        { id: 10, q: t('faq.q10'), r: t('faq.r10') },
    ];

    return (
        <div>
            <div className='faq'>
                {/* <img src="assets/Backgrounds/motif.png" alt="FAQ Banner" className='faq_motif' /> */}
                <div className='pt-10' ><Nav /></div>
                <div className='faq_all' data-aos="zoom-in" >  
                    <div className='faq_titles'>
                        <h1 className='w-2 text-s titre' >{t('faq.title')}</h1>
                    </div>

                    <div className='buttons'>
                        <RouterLink to="/" className='plf faq_button2'>
                            <FaLongArrowAltLeft />
                            {t('faq.button')}
                        </RouterLink>
                    </div>
                </div>

            </div>
            <div className='faq_content plf' data-aos="fade-up" >
                <h3>{t('faq.subtitle')}</h3>


                <div className="faq-list-container plf " style={{ maxWidth: '800px', margin: '20px auto' }}>

                    {donneesFAQ.map(item => (
<QuestionReponse
    key={item.id}
    question={item.q}
    reponse={item.r}
    isOpen={item.id === openQuestionId} 
    onClick={() => handleToggle(item.id)} 
/>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FAQ;